import { Card } from '@components/atoms/Card';
import { Checkbox } from '@components/atoms/Checkbox';
import { useState } from 'react';

export const CheckboxGroup = () => {
  const [checked, setChecked] = useState(false);

  return (
    <Card>
      <h2 className="text-lg text-gray-900 dark:text-white font-bold">
        Checkbox
      </h2>
      <div className="flex gap-6 mt-4">
        <Checkbox
          error={false}
          label="Checkbox"
          checked={checked}
          disabled={false}
          required={false}
          onChange={() => setChecked(!checked)}
        />
        <Checkbox
          error
          label="Checkbox"
          checked={false}
          onChange={() => setChecked(!checked)}
        />
        <Checkbox
          disabled
          label="Checkbox"
          onChange={() => setChecked(!checked)}
        />
      </div>
    </Card>
  );
};
